<template>
  <div v-if="recent.length">
    <slot/>

    <div class="flex gap-3 lg:gap-6 pt-8 pb-6 overflow-x-auto">
      <state-card
        v-for="state in recent"
        :key="state.code"
        class="min-w-72"
        :state="state"
      />
    </div>
  </div>
</template>

<script setup>
import StateCard from "@/components/cards/StateCard.vue"
import { computed } from "vue"
import { find, pull } from "lodash-es"
import { useStates } from "@/composables/useStates"

const props = defineProps({
  exclude: Object,
})

const { states } = useStates()

const storage = JSON.parse(localStorage.getItem("recentlyViewedStates")) || []

const recent = computed(() => {
  const codes = pull(storage, props.exclude?.code).slice(0, 6)

  return states.length ? codes.map(code => find(states, { code })) : []
})
</script>
